import React from 'react';
import './IPadMockup.css';

const IPadMockup = () => {
  return (
    <div className="ipad-mockup-container">
      <div className="ipad-frame">
        <div className="ipad-screen">
          <div className="ipad-content explorer-board-mockup">
            {/* Header */}
            <div className="mockup-header">
              <div className="mockup-logo">Ideal Scribe</div>
              <div className="mockup-tabs">
                <span className="mockup-tab inactive">Quick Notes</span>
                <span className="mockup-tab active">Explorer Board</span>
                <span className="mockup-tab inactive">Pack-it</span>
              </div>
            </div>

            {/* Main Content */}
            <div className="mockup-main-content">
              {/* Left Panel - Journey List */}
              <div className="mockup-left-panel">
                <div className="mockup-panel-header">
                  <h3>My Explorer Board</h3>
                  <div className="mockup-controls">
                    <button className="mockup-btn-primary">Add Journey</button>
                  </div>
                </div>
                <div className="mockup-summary">Showing 6 Total 6 Page 1 of 1</div>
                
                {/* Journey Items */}
                <div className="mockup-journey-list">
                  <div className="mockup-journey-item">
                    <div className="mockup-journey-header">
                      <h4>World Continents Journey</h4>
                      <div className="mockup-journey-icons">
                        <span className="mockup-icon">📍7</span>
                      </div>
                    </div>
                    <p className="mockup-journey-desc">Explore all continents of the world</p>
                    <div className="mockup-progress-bar">
                      <div className="mockup-progress-fill" style={{ width: '28.6%' }}></div>
                    </div>
                    <div className="mockup-progress-text">28.6% Complete</div>
                  </div>

                  <div className="mockup-journey-item">
                    <div className="mockup-journey-header">
                      <h4>United States States and Territories</h4>
                      <div className="mockup-journey-icons">
                        <span className="mockup-icon">📍56</span>
                      </div>
                    </div>
                    <p className="mockup-journey-desc">Complete list of all US states and territories</p>
                    <div className="mockup-progress-bar">
                      <div className="mockup-progress-fill" style={{ width: '8.9%' }}></div>
                    </div>
                    <div className="mockup-progress-text">8.9% Complete</div>
                  </div>

                  <div className="mockup-journey-item">
                    <div className="mockup-journey-header">
                      <h4>US National Monument Journey</h4>
                      <div className="mockup-journey-icons">
                        <span className="mockup-icon">📍87</span>
                      </div>
                    </div>
                    <p className="mockup-journey-desc">Explore 87 national monument locations</p>
                    <div className="mockup-progress-bar">
                      <div className="mockup-progress-fill" style={{ width: '0%' }}></div>
                    </div>
                    <div className="mockup-progress-text">0.0% Complete</div>
                  </div>

                  <div className="mockup-journey-item">
                    <div className="mockup-journey-header">
                      <h4>European Capitals Tour</h4>
                      <div className="mockup-journey-icons">
                        <span className="mockup-icon">📍44</span>
                      </div>
                    </div>
                    <p className="mockup-journey-desc">Visit all European capital cities</p>
                    <div className="mockup-progress-bar">
                      <div className="mockup-progress-fill" style={{ width: '15.9%' }}></div>
                    </div>
                    <div className="mockup-progress-text">15.9% Complete</div>
                  </div>

                  <div className="mockup-journey-item">
                    <div className="mockup-journey-header">
                      <h4>Pacific Coast Highway</h4>
                      <div className="mockup-journey-icons">
                        <span className="mockup-icon">📍23</span>
                      </div>
                    </div>
                    <p className="mockup-journey-desc">Scenic stops along California's PCH</p>
                    <div className="mockup-progress-bar">
                      <div className="mockup-progress-fill" style={{ width: '43.5%' }}></div>
                    </div>
                    <div className="mockup-progress-text">43.5% Complete</div>
                  </div>

                  <div className="mockup-journey-item">
                    <div className="mockup-journey-header">
                      <h4>National Parks Adventure</h4>
                      <div className="mockup-journey-icons">
                        <span className="mockup-icon">📍63</span>
                      </div>
                    </div>
                    <p className="mockup-journey-desc">Explore all US National Parks</p>
                    <div className="mockup-progress-bar">
                      <div className="mockup-progress-fill" style={{ width: '12.7%' }}></div>
                    </div>
                    <div className="mockup-progress-text">12.7% Complete</div>
                  </div>
                </div>
              </div>

              {/* Right Panel - Map */}
              <div className="mockup-right-panel">
                <div className="mockup-map-container">
                  <div className="mockup-map-search">
                    <input type="text" placeholder="Search for a place" className="mockup-search-input" />
                  </div>
                  <div className="mockup-map">
                    {/* Legend */}
                    <div className="mockup-legend">
                      <div className="mockup-legend-header">
                        <span>Legend</span>
                        <span className="mockup-legend-caret">▲</span>
                      </div>
                      <div className="mockup-legend-items">
                        <div className="mockup-legend-item">
                          <div className="mockup-legend-color red"></div>
                          <span>Food</span>
                        </div>
                        <div className="mockup-legend-item">
                          <div className="mockup-legend-color orange"></div>
                          <span>History</span>
                        </div>
                        <div className="mockup-legend-item">
                          <div className="mockup-legend-color green"></div>
                          <span>Hiking Trails</span>
                        </div>
                        <div className="mockup-legend-item">
                          <div className="mockup-legend-color blue"></div>
                          <span>Playgrounds</span>
                        </div>
                        <div className="mockup-legend-item">
                          <div className="mockup-legend-color yellow"></div>
                          <span>Culture</span>
                        </div>
                        <div className="mockup-legend-item">
                          <div className="mockup-legend-color purple"></div>
                          <span>Fishing Spots</span>
                        </div>
                        <div className="mockup-legend-item">
                          <div className="mockup-legend-color cyan"></div>
                          <span>Beaches</span>
                        </div>
                      </div>
                    </div>

                    <div className="mockup-map-content">
                      {/* Map PNG Image */}
                      <img 
                        src="/images/map.png" 
                        alt="Map" 
                        className="mockup-map-image"
                      />
                      
                      {/* Various Category Markers */}
                      <div className="mockup-map-markers">
                        {/* Red - Food */}
                        <div className="mockup-marker category red" style={{ top: '38%', left: '18%' }}></div>
                        <div className="mockup-marker category red" style={{ top: '62%', left: '52%' }}></div>
                        
                        {/* Green - Forests */}
                        <div className="mockup-marker category green" style={{ top: '25%', left: '20%' }}></div>
                        <div className="mockup-marker category green" style={{ top: '42%', left: '32%' }}></div>
                        
                        {/* Yellow - Outdoors */}
                        <div className="mockup-marker category yellow" style={{ top: '45%', left: '30%' }}></div>
                        <div className="mockup-marker category yellow" style={{ top: '43%', left: '32%' }}></div>
                        <div className="mockup-marker category yellow" style={{ top: '44%', left: '34%' }}></div>
                        
                        {/* Purple - Wildlife */}
                        <div className="mockup-marker category purple" style={{ top: '44%', left: '34%' }}></div>
                        
                        {/* Blue - Parks */}
                        <div className="mockup-marker category blue" style={{ top: '40%', left: '68%' }}></div>
                        
                        {/* Completed Notes/Journeys (Blue outline with checkmark) */}
                        <div className="mockup-marker completed" style={{ top: '40%', left: '20%' }}>
                          <span className="mockup-checkmark">✓</span>
                        </div>
                        <div className="mockup-marker completed" style={{ top: '42%', left: '25%' }}>
                          <span className="mockup-checkmark">✓</span>
                        </div>
                        <div className="mockup-marker completed" style={{ top: '38%', left: '48%' }}>
                          <span className="mockup-checkmark">✓</span>
                        </div>
                        <div className="mockup-marker completed" style={{ top: '40%', left: '50%' }}>
                          <span className="mockup-checkmark">✓</span>
                        </div>
                        <div className="mockup-marker completed" style={{ top: '42%', left: '52%' }}>
                          <span className="mockup-checkmark">✓</span>
                        </div>
                        <div className="mockup-marker completed" style={{ top: '48%', left: '54%' }}>
                          <span className="mockup-checkmark">✓</span>
                        </div>
                        <div className="mockup-marker completed" style={{ top: '58%', left: '48%' }}>
                          <span className="mockup-checkmark">✓</span>
                        </div>
                        <div className="mockup-marker completed" style={{ top: '60%', left: '52%' }}>
                          <span className="mockup-checkmark">✓</span>
                        </div>
                        <div className="mockup-marker completed" style={{ top: '62%', left: '30%' }}>
                          <span className="mockup-checkmark">✓</span>
                        </div>
                        <div className="mockup-marker completed" style={{ top: '65%', left: '48%' }}>
                          <span className="mockup-checkmark">✓</span>
                        </div>
                      </div>
                      
                      {/* <div className="mockup-map-labels">
                        <span className="mockup-label">United States</span>
                        <span className="mockup-label">Canada</span>
                        <span className="mockup-label">Mexico</span>
                      </div> */}
                      
                    </div>
                    <div className="mockup-map-controls">
                      <button className="mockup-map-btn">+</button>
                      <button className="mockup-map-btn">-</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IPadMockup;
